import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { AppState } from '../reducers/rootReducer';

const _selectDefaultLayout = (state: AppState) => state.Common.defaultLayout;

export const selectDefaultLayout = createDraftSafeSelector(
  _selectDefaultLayout,
  payload => payload,
);
